export default __webpack_public_path__ + "static/media/thumbnail.7b9194bd.png";